import Layout from '@layout/Index'

export const stepTemplate = [
  {
    path: '/step-template',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "step-template-form" */ './pages/StepTemplateForm.vue'),
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "step-template-workspace" */ './pages/StepTemplateWorkspace.vue'),
            name: '添加分步模板',
            meta: {
              title: '添加分步模板',
            },
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "step-template-workspace" */ './pages/StepTemplateWorkspace.vue'),
            name: '修改分步模板',
            meta: {
              title: '修改分步模板',
            },
          },
        ],
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "step-template-table" */ './pages/StepTemplateTable.vue'),
        name: '分步模板列表',
        meta: {
          title: '分步模板列表',
        },
      },
      {
        path: 'table/type/:type',
        component: () => import(/* webpackChunkName: "step-template-table" */ './pages/StepTemplateTable.vue'),
        meta: {
          title: '分步模板列表',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "step-template-detail" */ './pages/StepTemplateDetail.vue'),
        name: '分步模板详情',
        meta: {
          title: '分步模板详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/step-template/step-template.route.js